export default __webpack_public_path__ + "static/media/mm_logo_final_black.1b28d5a0.png";